//const cmsApiBase = 'https://ffw.platform-3.co.uk/wp-json/jv/v2';
//const cmsApiBase = 'http://localhost:3051/api';
const cmsApiBase = '/api';

export default {
  version: 15,
  cmsApi: {
    //posts: cmsApiBase + '/posts/?per_page=20&page=1',
    posts: cmsApiBase + '/posts',
    site: cmsApiBase + '/site'
  },
  mainPageAlias: 'main',
  auth: {
    name: 'porpoise',
    pass: '12india9'
  },
  imageStyles: {
    standard: [
      { maxWidth: 768, size: 'medium_natural' },
      { minWidth: 769, size: 'large_natural' }
    ],
    wide2_41: [
      { maxWidth: 768, size: 'medium_wide2_41' },
      { minWidth: 769, size: 'large_wide2_41' }
    ]
  }
}
